/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './dep-eba62589.mjs';
import { _ as _baseGetTag } from './dep-7d9e11c8.mjs';
import { i as isObjectLike_1 } from './dep-a6022780.mjs';

var baseGetTag = _baseGetTag,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}
var isNumber_1 = isNumber;

export { isNumber_1 as i };
//# sourceMappingURL=dep-961339ce.mjs.map
